import type { messages } from '../../../common/messages';

import type { ManagedBlockSource } from './types';

export type SourceValidationError = 'invalid' | 'pending' | 'required' | null;

export const getSourceValidationError = ({
	requireSource,
	sourceEntries,
}: {
	requireSource: boolean;
	sourceEntries: ManagedBlockSource[];
}): SourceValidationError => {
	if (sourceEntries.length === 0) {
		return requireSource ? 'required' : null;
	}

	if (sourceEntries.some((source) => source.status === 'resolving')) {
		return 'pending';
	}

	if (sourceEntries.some((source) => source.status === 'invalid')) {
		return 'invalid';
	}

	if (requireSource && !sourceEntries.some((source) => source.status === 'resolved')) {
		return 'required';
	}

	return null;
};

export const getSourceValidationMessageKey = (
	sourceValidationError: SourceValidationError,
): keyof typeof messages | null => {
	switch (sourceValidationError) {
		case 'invalid':
			return 'sourceInvalidError';
		case 'pending':
			return 'sourcePendingError';
		case 'required':
			return 'sourceRequiredError';
		default:
			return null;
	}
};
